import { REACT_APP_BASE_URL_METIS } from "../constants/enviroments";
import axios from "axios";
import { interceptorHelper } from "./interceptor";
import { handleAxiosError } from "./Axios";

const baseUrl = `${REACT_APP_BASE_URL_METIS}`;

let AuthAxios = axios.create({
  baseURL: `${baseUrl}`,
});

AuthAxios.interceptors.request.use(
  interceptorHelper.config,
  interceptorHelper.error
);

AuthAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    return handleAxiosError(error);
  }
);

export async function loginUser(data) {
  return AuthAxios.post(`users/login`, data);
}

export async function GetUser() {
  return AuthAxios.get(`/users/me`);
}

export async function registerUser(data) {
  return AuthAxios.post(`users/signup`, data);
}

export async function forgotPassword(data) {
  return AuthAxios.post(`users/forgot-password`, data);
}

export async function resetPassword(data) {
  return AuthAxios.post(`users/reset-password`, data);
}

export async function changePassword(data) {
  return AuthAxios.post(`users/change-password`, data);
}

export async function getLearnerDetails() {
  return AuthAxios.get(`users`);
}
export async function getInstructorDetails() {
  return AuthAxios.get(`instructors`);
}

export async function updateInstructorDetails(data) {
  return AuthAxios.put(`instructors`, data);
}

export async function updateUserById(data) {
  return AuthAxios.put(`users`, data);
}

export async function UpdateUser(data) {
  return AuthAxios.put(`users`, data);
}

export async function updateUserInformation(data) {
  return AuthAxios.put(`users/me`, data);
}

export function GetCategories() {
  return AuthAxios.get(`/v1/categories`);
}
